import React from 'react';
import { useAppDispatch, useAppSelector } from '@src/core/hooks';
import { currencySelector, setGlobalParameter } from '@src/stores/globalParameters';
import { directLinkStateSelector, loadDirectLink } from '@src/stores/directLink';
import { DEFAULT_AVAILABLE_CURRENCIES, SUPPORTED_CURRENCIES } from '@src/common/currency';
import { Container, CurrencyButton, GlobalIcon, ButtonGroup, FlagWrapper } from './styles';
import { TbWorldDollar } from 'react-icons/tb';

interface CurrencySelectorProps {
  availableCurrencies?: string[];
}

const CurrencySelector = ({ availableCurrencies = DEFAULT_AVAILABLE_CURRENCIES }: CurrencySelectorProps) => {
  const dispatch = useAppDispatch();
  const currentCurrency = useAppSelector(currencySelector);
  const { directLink } = useAppSelector(directLinkStateSelector);

  const handleSelect = (code: string) => {
    if (code === currentCurrency) return;

    dispatch(setGlobalParameter('currency', code));

    if (directLink?.code) {
      dispatch(loadDirectLink(directLink.code));
    }
  };

  const currencies = SUPPORTED_CURRENCIES.filter((c) => availableCurrencies.includes(c.code));

  return (
    <Container>
      <GlobalIcon>
        <TbWorldDollar size={24} />
      </GlobalIcon>
      <ButtonGroup>
        {currencies.map((curr) => (
          <CurrencyButton
            key={curr.code}
            $selected={currentCurrency === curr.code}
            onClick={() => handleSelect(curr.code)}
            type='button'
          >
            <FlagWrapper>
              <curr.flagSrc aria-label={curr.label} />
            </FlagWrapper>
            {curr.shortLabel}
          </CurrencyButton>
        ))}
      </ButtonGroup>
    </Container>
  );
};

export default CurrencySelector;
